import { appsApi } from '../api/endpoints/apps';

/**
 * Opens the app's own management page in a new tab. Zero signs a short-lived
 * token so the app can identify the merchant directly; without it the app would
 * have to bounce them through the OAuth consent screen, which looks like a
 * reinstall. Because that signature is fetched asynchronously, the tab has to be
 * opened synchronously inside the click handler or the popup blocker eats it.
 *
 * The features string deliberately omits `noopener`: passing it makes
 * window.open return null even on success, which left an orphaned about:blank
 * tab behind while the dashboard navigated itself away. Nulling `opener` on the
 * still-same-origin about:blank window severs the reference just as well.
 *
 * @returns false if the popup was blocked and nothing was opened.
 */
export async function openAppManagePage(
  storeId: string,
  appId: string,
  manageUrl: string | null | undefined,
): Promise<boolean> {
  if (!manageUrl) return false;

  const tab = window.open('', '_blank');
  if (!tab) return false;
  tab.opener = null;

  try {
    tab.location.href = await appsApi.manageUrl(storeId, appId);
    return true;
  } catch (err) {
    tab.close();
    throw err;
  }
}
